// Display only: never substitute these labels for the API's policy identifiers.
const labels: Record<string, string> = {
  client: 'Client', approved_lender: 'Approved lender', original_sender: 'Sender of received email',
  claims_team: 'Claims team', loa_team: 'Letter of authority team', closure_team: 'Closure team',
  cancellations_team: 'Cancellations team', closed_claim_forward_team: 'Closed claim correspondence team',
  source_email: 'Received email', source_attachments: 'Original attachments',
  generic: 'General email', loa_portal: 'Letter of authority request', multi_rep: 'Multi-representation notice',
  multi_rep_reminder: 'Multi-representation reminder', cancel_confirmation: 'Reaffirm authority',
  forward_correspondence: 'Forward correspondence',
};
export const policyLabel = (value: string): string => labels[value] || value;
export const attachmentLabels = (values: string[]): string => values.map(policyLabel).join(', ') || 'None';
